import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { useState } from 'react';
export function useNavigableDialog(initContent, props) {
  var _useState = useState(function () {
      return initContent;
    }),
    _useState2 = _slicedToArray(_useState, 2),
    _Component = _useState2[0],
    setComponent = _useState2[1];
  var _useState3 = useState(props),
    _useState4 = _slicedToArray(_useState3, 2),
    _dialogProps = _useState4[0],
    setDialogProps = _useState4[1];
  function replaceContent(Component, dialogProps) {
    setComponent(function () {
      return Component;
    });
    setDialogProps(dialogProps);
  }
  return {
    Component: _Component,
    dialogProps: _dialogProps,
    replaceContent: replaceContent
  };
}